import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  light?: boolean;
  compact?: boolean;
}
export function CountdownTimer({
  light = false,
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 10,
    seconds: 43
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const textColor = light ? 'text-white' : 'text-blue-900';
  const bgColor = light ? 'bg-white/20' : 'bg-white shadow-md';
  if (compact) {
    return <div className="flex items-center gap-1 font-bold text-white bg-red-700/50 px-3 py-1 rounded-md border border-red-500/30" data-id="element-47">
        <span data-id="element-48">{format(timeLeft.hours)}</span>:
        <span data-id="element-49">{format(timeLeft.minutes)}</span>:
        <span data-id="element-50">{format(timeLeft.seconds)}</span>
      </div>;
  }
  return <div className="flex items-center justify-center gap-2 sm:gap-4 font-bold" data-id="element-51">
      <div className={`flex flex-col items-center ${bgColor} rounded-lg p-2 sm:p-3 min-w-[60px] sm:min-w-[80px]`} data-id="element-52">
        <span className={`text-2xl sm:text-4xl ${textColor}`} data-id="element-53">
          {format(timeLeft.hours)}
        </span>
        <span className={`text-xs sm:text-sm ${textColor} opacity-80 uppercase mt-1`} data-id="element-54">
          Ore
        </span>
      </div>
      <span className={`text-2xl sm:text-4xl ${textColor} animate-pulse`} data-id="element-55">
        :
      </span>
      <div className={`flex flex-col items-center ${bgColor} rounded-lg p-2 sm:p-3 min-w-[60px] sm:min-w-[80px]`} data-id="element-56">
        <span className={`text-2xl sm:text-4xl ${textColor}`} data-id="element-57">
          {format(timeLeft.minutes)}
        </span>
        <span className={`text-xs sm:text-sm ${textColor} opacity-80 uppercase mt-1`} data-id="element-58">
          Min
        </span>
      </div>
      <span className={`text-2xl sm:text-4xl ${textColor} animate-pulse`} data-id="element-59">
        :
      </span>
      <div className={`flex flex-col items-center ${bgColor} rounded-lg p-2 sm:p-3 min-w-[60px] sm:min-w-[80px]`} data-id="element-60">
        <span className={`text-2xl sm:text-4xl ${textColor}`} data-id="element-61">
          {format(timeLeft.seconds)}
        </span>
        <span className={`text-xs sm:text-sm ${textColor} opacity-80 uppercase mt-1`} data-id="element-62">
          Sec
        </span>
      </div>
    </div>;
}